import React from 'react';
import { EligibilityStatsComponent } from './EligibilityStats';
import { Box } from '@material-ui/core';

/**
 * Overview page for Eligibility that displays statistics
 */
export const EligibilityOverviewPage: React.FC = () => {
  return (
    <Box>
      <EligibilityStatsComponent />
    </Box>
  );
};

export default EligibilityOverviewPage;
